import { render, staticRenderFns } from "./NosologiaSelectCard.vue?vue&type=template&id=4624b0aa&scoped=true&"
import script from "./NosologiaSelectCard.vue?vue&type=script&lang=js&"
export * from "./NosologiaSelectCard.vue?vue&type=script&lang=js&"
import style0 from "./NosologiaSelectCard.vue?vue&type=style&index=0&id=4624b0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624b0aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCheckbox,VProgressCircular})
